import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { systemUser } from "../config/constants/system-users";
import appRoutePath from "../config/path";
import DashboardMainPage from "../pages/dashboard/DashboardMain";

export const DashboardRedirect: React.FC = () => {
  const currentUser = useAppSelector((state) => state.authVerify);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser.role === systemUser.STAFF) {
      navigate(appRoutePath.ASSET_IN_MY_POSSESSION_PAGE, { replace: true });
    }
  }, [currentUser.role, navigate]);

  if (currentUser.role === systemUser.STAFF) {
    return null;
  }

  return <DashboardMainPage />;
};
